<!-- 资金管理-审批列表 -->
<template>
  <div class="page">
    <div class="form">
      <el-form :inline="true" :model="form" ref="formRef" size="small">
        <el-form-item v-if="ROLE_TYPE.isManager()" :label="$t('text.merchantName')">
          <el-select
              v-model="form.appId"
              filterable
              :placeholder="$t('message.chooseOne')"
              popper-class="eloption"
          >
            <el-option :label="$t('option.all')" value=""></el-option>
            <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="ROLE_TYPE.isManager()" :label="$t('text.agentName')">
          <el-select
              v-model="form.agentId"
              filterable
              :placeholder="$t('message.chooseOne')"
              popper-class="eloption"
          >
            <el-option :label="$t('option.all')" value=""></el-option>
            <el-option
                v-for="agent in agentList"
                :label="agent.agentId + '-' + agent.agentName"
                :key="agent.agentId"
                :value="agent.agentId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.date')">
          <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              :range-separator="$t('text.to')"
              :start-placeholder="$t('text.startDate')"
              :end-placeholder="$t('text.endDate')"
              @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>

        <div class="item_button">
          <el-form-item style="margin-bottom: 0">
            <el-button :loading="loading" type="primary" @click="onSubmit">
              {{ $t('text.search') }}
            </el-button>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button :loading="loading" type="primary" @click="onReset">
              {{ $t('text.reset') }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div>
      <el-card shadow="never" style="margin-bottom: 10px">
        <el-row type="flex" align="middle" justify="center">
          <el-col :span="6" class="colStyle">
            <div>{{ $t('text.pendingSettlement') }}</div>
            <div>{{ waitSettleAmount }}</div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  props: {
    fromMerchantList: {
      type: Array,
      default() {
        return [];
      }
    },
    fromAgentList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      waitSettleAmount: "0.00",
      form: {
        appId: "",
        agentId: "",
        startDate: "",
        endDate: ""
      },

      timeDate: [],
      merchantList: [],
      agentList: []
    };
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.waitSettleAmount = "...";
      this.axios
          .get("/merchant/getWaitSettleAmount", {params: this.form})
          .then((res) => {
            if (res.code === 200) {
              this.waitSettleAmount = this.$formatter.FenToYuanToThousandth(
                  null,
                  null,
                  res.data.waitSettleAmount,
                  null
              );
            }
          });
      this.loading = false;
    },
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    onReset() {
      this.form = {
        appId: "",
        agentId: "",
        startDate: "",
        endDate: "",
      };
      this.timeDate = [];
    }
  },
  watch: {
    fromMerchantList() {
      this.merchantList = this.fromMerchantList;
      if (this.merchantList.length === 1) {
        this.form.appId = this.merchantList[0].value;
        this.$bus.$emit("refresh");
      }
    },
    fromAgentList() {
      this.agentList = this.fromAgentList;
      if (this.fromAgentList.length === 1) {
        this.form.agentId = this.fromAgentList[0].value;
        this.$bus.$emit("refresh");
      }
    }
  }
};
</script>
<style scoped>
.page {
  background: transparent;
  text-align: left;
  border: 1px solid #dce4ea;
}

.form {
  border-bottom: 1px solid #dce4ea;
  padding: 10px;
  background-color: #ffffff;
}

.item_button {
  display: initial;
}

.colStyle {
  text-align: center;
  line-height: 34px;
}
</style>